import { useEffect, useState } from 'react'

import { Checkbox, Input, MultiSelect, Select } from '@base'
import { enquiryInputType, strings } from '@constants'
import {
	BiInputWrapper,
	FormELementLabelWrapper,
	FormWrapper,
	SectionItemWrapper,
	SectionItemWrapperWithTwoItems,
} from '@pages/Admin/SalesPurchaseOrder2/style'

const CreateItemForm = ({ edit = false, formState, updateFormState, isScrap }) => {
	const { category, product, brand, allotted_weight, inputType, price_per_kg, grade, hsn_code, tc_required } = formState
	const [preferredUnits, setPrefferedUnits] = useState([])

	useEffect(() => {
		const filteredUnits = Object.keys(enquiryInputType).filter((key) => category.value?.preferred_units?.includes(key))
		setPrefferedUnits(filteredUnits.map((key) => ({ key: key, label: enquiryInputType[key] })))
	}, [product, category])

	useEffect(() => {
		updateFormState('inputType', { value: inputType?.value ? inputType?.value : preferredUnits?.[0]?.key })
	}, [preferredUnits])

	const onChange = (key) => (value) => {
		if (key === 'category') {
			updateFormState('hsn_code', { value: value?.hsn_code })
			updateFormState('brands', { value: [] })
			updateFormState('inputType', { value: '' })
		} else if (key === 'product') {
		}
		updateFormState(key, { value, dirty: true })
	}

	const returnLabel = (label) => {
		if (label === enquiryInputType.LENGTH) {
			return strings('length')
		} else if (label === enquiryInputType.PIECES) {
			return strings('pieces')
		} else if (label === enquiryInputType.WEIGHT) {
			return strings(['weight', '(', 'mt', ')'])
		} else if (label === enquiryInputType.SET) {
			return strings('set')
		} else if (label === enquiryInputType.NUMBER) {
			return strings('number')
		} else if (label === enquiryInputType.POWER) {
			return strings('power')
		}
	}

	const selectedBrandUi = () => {
		return (
			<SectionItemWrapper>
				<Select
					id='order-item-brand-select'
					disabled={brand?.disabled}
					label={brand?.label}
					displayKey={brand?.displayKey}
					primaryKey={brand?.primaryKey}
					placeholder={brand?.placeholder}
					data={brand?.data}
					value={brand?.value}
					onChange={onChange('brand')}
				/>
			</SectionItemWrapper>
		)
	}
	const simpleProductUi = () => {
		return (
			<>
				<SectionItemWrapper>
					{isScrap ? (
						<MultiSelect
							id='enquiry-product-select'
							label={product?.label}
							displayKey={product?.displayKey}
							primaryKey={product?.primaryKey}
							placeholder={product?.placeholder}
							data={product?.data}
							value={product?.value?.length > 0 ? product?.value : []}
							onChange={onChange('product')}
							disabled={product?.disabled || edit}
							createNewOption={true}
						/>
					) : (
						<Select
							id='order-product-select'
							label={product?.label}
							displayKey={product?.displayKey}
							primaryKey={product?.primaryKey}
							placeholder={product?.placeholder}
							data={product?.data}
							value={product?.value}
							onChange={onChange('product')}
							disabled={product?.disabled || edit}
							createNewOption={true}
						/>
					)}
				</SectionItemWrapper>
				{selectedBrandUi()}
				<SectionItemWrapper>
					{isScrap ? (
						<Input
							type='number'
							disabled={allotted_weight?.disabled}
							label={allotted_weight?.label}
							value={allotted_weight?.value}
							onChange={onChange('allotted_weight')}
						/>
					) : (
						<BiInputWrapper>
							<Input
								type='number'
								disabled={allotted_weight?.disabled}
								label={returnLabel(inputType?.value)}
								value={allotted_weight?.value}
								onChange={onChange('allotted_weight')}
							/>
							<Select
								id='selected-unit'
								label={inputType?.label}
								placeholder={inputType?.placeholder}
								data={preferredUnits ?? []}
								displayKey='label'
								primaryKey='key'
								value={preferredUnits?.find((item) => item?.key === inputType.value) ?? {}}
								onChange={(val) => onChange('inputType')(val.key)}
								disabled={edit}
							/>
						</BiInputWrapper>
					)}
				</SectionItemWrapper>
				<SectionItemWrapper>
					<BiInputWrapper>
						<Input
							type='number'
							label={strings(['price', 'per', returnLabel(inputType?.value)])}
							disabled={price_per_kg?.disabled}
							value={price_per_kg?.value}
							onChange={onChange('price_per_kg')}
						/>
						<Input
							type='text'
							// disabled={grade?.disabled}
							label={grade?.label}
							placeholder={grade?.placeholder}
							value={grade?.value}
							disabled={grade?.disabled || edit}
							onChange={(val) => onChange('grade')(val?.trim())}
							uppercase={true}
						/>
					</BiInputWrapper>
				</SectionItemWrapper>
			</>
		)
	}

	const productNameUi = () => {
		// TODO ->tmt ui
		return simpleProductUi()
	}

	const onCheckBoxChange = (e) => {
		onChange('tc_required')(e.target.checked)
	}

	return (
		<FormWrapper>
			<SectionItemWrapper>
				<Select
					id='order-category-select'
					disabled={category?.disabled || edit}
					label={category?.label}
					displayKey={category?.displayKey}
					primaryKey={category?.primaryKey}
					placeholder={category?.placeholder}
					data={category?.data}
					value={category?.value}
					onChange={onChange('category')}
				/>
			</SectionItemWrapper>
			{productNameUi()}
			<SectionItemWrapper>
				<Input
					type='tel'
					maxLength={8}
					label={hsn_code?.label}
					placeholder={strings(['enter', 'hsn', 'code'])}
					disabled={hsn_code?.disabled}
					value={hsn_code?.value}
					onChange={(val) => onChange('hsn_code')(val?.trim())}
				/>
			</SectionItemWrapper>
			<SectionItemWrapperWithTwoItems>
				<Checkbox
					id='Checkbox'
					size={1.125}
					disabled={tc_required?.disabled}
					checked={tc_required?.value}
					value={tc_required?.value}
					onChange={onCheckBoxChange}
				/>
				<FormELementLabelWrapper disabled={tc_required?.disabled} htmlFor='Checkbox'>
					{tc_required?.label}
				</FormELementLabelWrapper>
			</SectionItemWrapperWithTwoItems>
		</FormWrapper>
	)
}

export default CreateItemForm
